module.exports = __webpack_public_path__ + "static/img/rz(9).a433c620.jpg";